/**
 * Portal Manta · Card5Orcamento
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { fmtNum, fmtBRL, extKm } from '../../globals.js';

const Card5Orcamento = memo(function Card5Orcamento_Inner({orcamento, loteRef, kpis}){
  if (!orcamento) return null;
  return (<div>
    {/* Card valor médio */}
    <div style={{padding:'18px 22px', background:`linear-gradient(135deg, ${M.green}, ${M.green}cc)`, color:'#fff', borderRadius:8, marginBottom:14, boxShadow:'0 4px 14px rgba(16,185,129,.25)'}}>
      <div style={{fontFamily:F.mono, fontSize:9.5, letterSpacing:1.5, textTransform:'uppercase', opacity:0.9, marginBottom:6}}>
        Orçamento estimado · valor médio (rotas A+B)
      </div>
      <div style={{fontFamily:F.mono, fontSize:28, fontWeight:700}}>
        {fmtBRL(orcamento.med, 0)}
      </div>
      <div style={{fontSize:11, opacity:0.9, marginTop:6}}>
        {fmtNum(kpis.extKm, 1)} km · referência: <b>{loteRef.sigla}</b> ({loteRef.uf})
      </div>
    </div>

    {/* Rota A | B */}
    <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14}}>
      <div style={{background:'#fff', border:`2px solid ${M.accent}`, borderRadius:6, overflow:'hidden'}}>
        <div style={{padding:'9px 14px', background:M.accent, color:'#fff', fontSize:11, fontWeight:700, letterSpacing:.5, textTransform:'uppercase', display:'flex', alignItems:'center', gap:8}}>
          <span style={{width:22, height:22, borderRadius:4, background:'#fff', color:M.accent, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:11}}>A</span>
          Caso similar · {loteRef.sigla}
        </div>
        <table style={{width:'100%', borderCollapse:'collapse', fontSize:10.5, fontFamily:F.body}}>
          <thead><tr style={{background:M.bgAlt}}>
            <th style={{padding:'6px 10px', textAlign:'left', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Categoria</th>
            <th style={{padding:'6px 10px', textAlign:'right', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Qtd</th>
            <th style={{padding:'6px 10px', textAlign:'right', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Custo</th>
          </tr></thead>
          <tbody>
            {orcamento.rotaA.map(it => (
              <tr key={it.k} style={{borderBottom:`1px solid ${M.borderSoft}`}}>
                <td style={{padding:'5px 10px', color:M.text}}>{it.l}</td>
                <td style={{padding:'5px 10px', textAlign:'right', fontFamily:F.mono, color:M.muted}}>{fmtNum(it.q,0)} {it.und}</td>
                <td style={{padding:'5px 10px', textAlign:'right', fontFamily:F.mono, fontWeight:600, color:M.accent}}>{fmtBRL(it.custo,0)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot><tr style={{background:'#FFF7ED', borderTop:`2px solid ${M.accent}`}}>
            <td colSpan={2} style={{padding:'8px 10px', fontWeight:800, color:M.accent, fontSize:11}}>SUBTOTAL A</td>
            <td style={{padding:'8px 10px', textAlign:'right', fontWeight:800, color:M.accent, fontFamily:F.mono, fontSize:12}}>{fmtBRL(orcamento.subA,0)}</td>
          </tr></tfoot>
        </table>
      </div>

      <div style={{background:'#fff', border:`2px solid ${M.blue}`, borderRadius:6, overflow:'hidden'}}>
        <div style={{padding:'9px 14px', background:M.blue, color:'#fff', fontSize:11, fontWeight:700, letterSpacing:.5, textTransform:'uppercase', display:'flex', alignItems:'center', gap:8}}>
          <span style={{width:22, height:22, borderRadius:4, background:'#fff', color:M.blue, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:11}}>B</span>
          Paramétrico · média da base
        </div>
        <table style={{width:'100%', borderCollapse:'collapse', fontSize:10.5, fontFamily:F.body}}>
          <thead><tr style={{background:M.bgAlt}}>
            <th style={{padding:'6px 10px', textAlign:'left', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Categoria</th>
            <th style={{padding:'6px 10px', textAlign:'right', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Qtd</th>
            <th style={{padding:'6px 10px', textAlign:'right', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Custo</th>
          </tr></thead>
          <tbody>
            {orcamento.rotaB.map(it => (
              <tr key={it.k} style={{borderBottom:`1px solid ${M.borderSoft}`}}>
                <td style={{padding:'5px 10px', color:M.text}}>{it.l}</td>
                <td style={{padding:'5px 10px', textAlign:'right', fontFamily:F.mono, color:M.muted}}>{fmtNum(it.q,0)} {it.und}</td>
                <td style={{padding:'5px 10px', textAlign:'right', fontFamily:F.mono, fontWeight:600, color:M.blue}}>{fmtBRL(it.custo,0)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot><tr style={{background:'#EFF6FF', borderTop:`2px solid ${M.blue}`}}>
            <td colSpan={2} style={{padding:'8px 10px', fontWeight:800, color:M.blue, fontSize:11}}>SUBTOTAL B</td>
            <td style={{padding:'8px 10px', textAlign:'right', fontWeight:800, color:M.blue, fontFamily:F.mono, fontSize:12}}>{fmtBRL(orcamento.subB,0)}</td>
          </tr></tfoot>
        </table>
      </div>
    </div>

    {/* Cross-validation */}
    <div style={{padding:'14px 16px', background:'#FEF3C7', borderLeft:`3px solid ${M.yellow}`, borderRadius:'0 6px 6px 0'}}>
      <div style={{fontSize:10, fontWeight:700, color:'#78350f', letterSpacing:.5, textTransform:'uppercase', marginBottom:10}}>Δ Cross-validation</div>
      <div style={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:14}}>
        <div>
          <div style={{fontSize:9, color:'#78350f', fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Mínimo</div>
          <div style={{fontFamily:F.mono, fontSize:14, fontWeight:800, color:M.green}}>{fmtBRL(orcamento.min, 0)}</div>
        </div>
        <div>
          <div style={{fontSize:9, color:'#78350f', fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Média</div>
          <div style={{fontFamily:F.mono, fontSize:16, fontWeight:800, color:M.heading}}>{fmtBRL(orcamento.med, 0)}</div>
        </div>
        <div>
          <div style={{fontSize:9, color:'#78350f', fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Máximo</div>
          <div style={{fontFamily:F.mono, fontSize:14, fontWeight:800, color:M.accent}}>{fmtBRL(orcamento.max, 0)}</div>
        </div>
        <div>
          <div style={{fontSize:9, color:'#78350f', fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Δ A vs B</div>
          <div style={{fontFamily:F.mono, fontSize:16, fontWeight:800, color: Math.abs(orcamento.deltaAB)<10?M.green:(Math.abs(orcamento.deltaAB)<25?M.blue:M.accent)}}>
            {orcamento.deltaAB>=0?'+':''}{orcamento.deltaAB.toFixed(1)}%
          </div>
          <div style={{fontSize:9, color:'#78350f', fontStyle:'italic', marginTop:1}}>
            {Math.abs(orcamento.deltaAB)<10 ? '✓ Convergência alta' : (Math.abs(orcamento.deltaAB)<25 ? '◐ Divergência moderada' : '⚠ Divergência alta')}
          </div>
        </div>
      </div>
    </div>
  </div>);
});

export { Card5Orcamento };
export default Card5Orcamento;
